import script from "./TimeInput.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeInput.vue?vue&type=script&setup=true&lang=js"

import "./TimeInput.vue?vue&type=style&index=0&id=0481fd54&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0481fd54"]])

export default __exports__
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPopupProxy,QSeparator,QBtn});
